import { render, staticRenderFns } from "./soft.vue?vue&type=template&id=99a53336&scoped=true&"
import script from "./soft.vue?vue&type=script&lang=js&"
export * from "./soft.vue?vue&type=script&lang=js&"
import style0 from "./soft.vue?vue&type=style&index=0&id=99a53336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a53336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99a53336')) {
      api.createRecord('99a53336', component.options)
    } else {
      api.reload('99a53336', component.options)
    }
    module.hot.accept("./soft.vue?vue&type=template&id=99a53336&scoped=true&", function () {
      api.rerender('99a53336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/soft.vue"
export default component.exports